import { render, staticRenderFns } from "./AulaAlert.vue?vue&type=template&id=1fd79c22&scoped=true&"
import script from "./AulaAlert.vue?vue&type=script&lang=ts&"
export * from "./AulaAlert.vue?vue&type=script&lang=ts&"
import style0 from "./AulaAlert.vue?vue&type=style&index=0&id=1fd79c22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd79c22",
  null
  
)

export default component.exports